import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_sandwich",
  "use": "svg_sandwich-usage",
  "viewBox": "0 0 20 18",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 18\" id=\"svg_sandwich\"><path d=\"M0 0h19.2v1.2H0V0ZM0 8.4h19.2v1.2H0V8.4ZM0 16.8h19.2V18H0v-1.2Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol